import List from "../../containers/SubCategories/List";
import Entry from "../../containers/SubCategories";

const SubCategoryRoutes = [
  {
    path: "/sub-categories",
    exact: true,
    auth: true,
    component: List,
  },
  {
    path: "/sub-categories/:type",
    exact: true,
    auth: true,
    component: Entry,
  },
  {
    path: "/sub-categories/:type/:id",
    exact: true,
    auth: true,
    component: Entry,
  },
];

export default SubCategoryRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/subCategories.jsx